import React, { useState } from "react";
import { SearchDropDownWithBase } from "../../../../components";
import queryString from "query-string";
// import utils from "../../../../utils";
// import {useNavigate} from "react-router-dom";
import values from "../../../../values";
import Context from "../../../../context";
import { IOnSearchUser } from "../../../../types/common.interface";
import utils from "../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";

interface iOnSearch {
  searchedValue: string;
  base: {
    title: string;
    value: string;
  };
}

const SearchAgent = () => {
  // ============================ Value Validations =========================

  // const navigate = useNavigate();
  const [defaultSearch, setDefaultSearch] = useState<string>(
    String(queryString.parse(window.location.search).search)?.split(":")[1]
  );
  const { requestParent, setRequestParent } = React.useContext(
    Context.ParentScreen
  );
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const { t } = useTranslation();
  let baseSearch =
    userType === "ADMIN"
      ? values.dropdownBaseSearch.PARENT_BASE_SEARCH
      : values.dropdownBaseSearch.PARENT_BASE_SEARCH_SUPERAGENT;

  baseSearch = baseSearch.map((item) => {
    return { ...item, title: t(item?.title) };
  });

  // =============================== Navigation =============================

  function onSearch(event: IOnSearchUser) {
    setRequestParent!({
      ...requestParent,
      search: {
        base: event?.base?.value,
        value: event?.searchedValue,
      },
    });
    return false;
  }

  // ============================== JSX Contents ============================

  return (
    <SearchDropDownWithBase
      icon="fa-solid fa-magnifying-glass"
      defaultSearch={defaultSearch}
      size="medium-sd"
      onChangeSearch={(event: IOnSearchUser) => {
        onSearch(event);
        setDefaultSearch(event.searchedValue);
      }}
      defaultBaseSearch={baseSearch[0]}
      baseSearchItems={baseSearch}
      placeHolder={t("search")}
    />
  );
};

export default SearchAgent;
